// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import { put, call, takeEvery } from 'redux-saga/effects';
// import * as firebase from 'firebase/app';
import ReactPixel from 'react-facebook-pixel';

import { registerService, registerSelectedAddressService } from './service';
import * as registerActions from './actions';
import * as loginActions from '../../login/store/actions';
import * as types from './actionTypes';

function* registerSaga(payload) {
  const res = yield call(registerService, payload.data);

  if (res.ok) {
    // firebase.analytics().logEvent('sign_up', {
    //   method: 'web',
    // });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'sign_up',
      method: 'custom', // sign-up method (google, facebook, custom)
      user_id: `${(JSON.parse(res?.body)).CustomerId}`,
    });
    ReactPixel.trackCustom(
      'complete_registration',
      { email: payload.data.EmailID }
    );
    const cartId = localStorage.getItem('CartID');
    const data = {
      email: payload.data.EmailID,
      password: payload.data.Password,
    };
    if (cartId) data.cartId = cartId;
    yield put(loginActions.requestLogin(data, payload.toCheckout, true));
  } else {
    yield put(registerActions.registerFailed(res.body));
  }
}

function* requestSelectedAddressSaga(payload) {
  const res = yield call(registerSelectedAddressService, payload.data);
  if (res.ok) {
    const address = res.body.result;
    if (address.postal_code) {
      yield put(registerActions.changeFieldAddress(address.postal_code, 'Postcode'));
    }
    if (address.line_1) {
      yield put(registerActions.changeFieldAddress(address.line_1, 'AddressLine1'));
    }
    if (address.line_2) {
      yield put(registerActions.changeFieldAddress(address.line_2, 'AddressLine2'));
    }
    if (address.locality) {
      yield put(registerActions.changeFieldAddress(address.locality, 'Town'));
    }
    if (address.province_name) {
      yield put(registerActions.changeFieldAddress(address.province_name, 'County'));
    }
  } else {
    yield put(registerActions.requestSelectedAddressFailed());
  }
}

const registerSagas = [
  takeEvery(types.REGISTER_REQUEST, registerSaga),
  takeEvery(types.REGISTER_SELECTED_ADDRESS_REQUEST, requestSelectedAddressSaga),
];

export default registerSagas;
